import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { PageLoading } from "../shared";
import { isAuthorized } from "../utils/authority";

/**
 * Restricts child routes to authenticated super admins while preserving
 * login redirects for unauthenticated users.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactNode}
 */
const RequireSuperAdmin = ({ children }) => {
  const { user, initialized } = useAuth();
  const location = useLocation();

  if (!initialized) {
    return <PageLoading />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.authority !== "superAdmin" && !isAuthorized("superAdmin")) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireSuperAdmin;
